import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "../components/modal";
import api from "../api/api"; 
import { getClientes, createCliente } from "../services/clientesservice";

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  
  const [isInventoryOpen, setIsInventoryOpen] = useState(false);
  const [isNewClientOpen, setIsNewClientOpen] = useState(false);
  
  const [selectedClient, setSelectedClient] = useState(null);
  const [inventory, setInventory] = useState([]);
  const [editingClientId, setEditingClientId] = useState(null);

  const initialClientState = {
    name: "", cnpj: "", state_registration: "", contact_person: "",
    whatsapp: "", email: "", zipcode: "", address: "", neighborhood: "",
    city: "", state_uf: "", notes: ""
  };

  const [newClient, setNewClient] = useState(initialClientState);

  // 🌍 BUSCA AUTOMÁTICA DE CEP (Mantida Original)
  const fetchAddressByCep = async (cepValue) => {
    const cepClean = cepValue.replace(/\D/g, "");
    if (cepClean.length === 8) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cepClean}/json/`);
        const data = await response.json();
        if (!data.erro) {
          setNewClient(prev => ({
            ...prev,
            address: data.logradouro ? data.logradouro.toUpperCase() : prev.address,
            neighborhood: data.bairro ? data.bairro.toUpperCase() : prev.neighborhood,
            city: data.localidade ? data.localidade.toUpperCase() : prev.city,
            state_uf: data.uf ? data.uf.toUpperCase() : prev.state_uf
          }));
        }
      } catch (err) { console.error("Erro ViaCEP:", err); }
    }
  };

  // ✨ FUNÇÕES DE MÁSCARA (Mantidas Originais)
  const maskCNPJ = (val) => val.replace(/\D/g, "").replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2").slice(0, 18);
  const maskPhone = (val) => val.replace(/\D/g, "").replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2").slice(0, 15);
  const maskCEP = (val) => val.replace(/\D/g, "").replace(/^(\d{5})(\d)/, "$1-$2").slice(0, 9);
  const maskUF = (val) => val.replace(/[^a-zA-Z]/g, "").toUpperCase().slice(0, 2);

  useEffect(() => { loadClientes(); }, []);

  function loadClientes() {
    setIsLoading(true);
    getClientes()
      .then(data => setClientes(Array.isArray(data) ? data : []))
      .finally(() => setIsLoading(false));
  }

  async function handleOpenInventory(cliente) {
    setSelectedClient(cliente);
    setIsInventoryOpen(true);
    try {
      const res = await api.get(`/clients/${cliente.id}/inventory`);
      setInventory(res.data || []);
    } catch (err) { console.error(err); }
  }

  function handleOpenEdit(cliente) {
    setEditingClientId(cliente.id);
    setNewClient({
      name: cliente.name || "",
      cnpj: cliente.cnpj || "",
      state_registration: cliente.state_registration || "",
      contact_person: cliente.contact || "",
      whatsapp: cliente.whatsapp || "",
      email: cliente.email || "",
      zipcode: cliente.zipcode || "",
      address: cliente.address || "",
      neighborhood: cliente.neighborhood || "",
      city: cliente.city || "",
      state_uf: cliente.state_uf || "",
      notes: cliente.notes || ""
    });
    setIsNewClientOpen(true);
  }

  function handleOpenCreate() {
    setEditingClientId(null);
    setNewClient(initialClientState);
    setIsNewClientOpen(true);
  }

  async function handleSave() {
    if (!newClient.name) return window.alert("O nome da empresa é obrigatório!");
    try {
      if (editingClientId) {
        await api.put(`/clients/${editingClientId}`, newClient);
        window.alert("Empresa atualizada! 💾");
      } else {
        await createCliente(newClient);
        window.alert("Empresa cadastrada! 🚀");
      }
      setIsNewClientOpen(false);
      loadClientes();
    } catch (err) { window.alert("Erro ao salvar cadastro."); }
  }

  async function handleDelete(cliente) {
    if (cliente.machines_count > 0) return window.alert("Bloqueado: Existem máquinas ativas neste contrato.");
    if (window.confirm(`Excluir permanentemente ${cliente.name}?`)) {
      try {
        await api.delete(`/clients/${cliente.id}`);
        loadClientes();
      } catch (err) { window.alert("Erro na exclusão."); }
    }
  }

  const filtered = clientes.filter(c => 
    (c.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (c.cnpj || "").includes(searchTerm)
  );

  return (
    <div className="p-2 md:p-8 lg:p-12 animate-in fade-in duration-500 pb-24 lg:pb-12">
      
      {/* 🔍 HEADER RESPONSIVO */}
      <div className="mb-6 md:mb-10 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 bg-white/70 backdrop-blur-xl p-6 md:p-10 rounded-[30px] md:rounded-[50px] border border-white/50 shadow-sm transition-all">
        <div>
          <h1 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tighter uppercase leading-none">
            Gestão de <span className="text-indigo-600">Clientes</span>
          </h1>
          <p className="text-[8px] md:text-[10px] text-slate-500 font-black uppercase tracking-[0.3em] mt-3">Base de Contratos Ativos</p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
          <div className="relative group w-full lg:w-80">
            <span className="absolute left-5 top-3.5 md:top-4 opacity-40 group-focus-within:text-indigo-600 transition-all text-lg">🔍</span>
            <input 
              placeholder="Buscar..." 
              className="w-full p-3.5 md:p-4 pl-14 bg-white/80 border border-slate-200 rounded-2xl text-sm font-bold text-slate-700 outline-none focus:ring-4 ring-indigo-500/10 focus:border-indigo-400 transition-all"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <button onClick={handleOpenCreate} className="w-full sm:w-auto px-8 py-4 bg-indigo-600 text-white font-black rounded-2xl shadow-lg hover:bg-indigo-500 hover:-translate-y-0.5 transition-all text-[10px] uppercase tracking-widest active:scale-95">
            + Novo Contrato
          </button>
        </div>
      </div>

      {/* 📋 TABELA COM SCROLL LATERAL PREVENTIVO */}
      <div className="bg-white/60 backdrop-blur-md rounded-[25px] md:rounded-[40px] border border-white/60 shadow-xl overflow-hidden">
        <div className="overflow-x-auto custom-scrollbar">
          <table className="w-full text-left min-w-[800px]">
            <thead className="bg-slate-50/60 text-[9px] md:text-[10px] uppercase font-black text-slate-500 tracking-widest border-b border-slate-200/50">
              <tr>
                <th className="p-6 md:p-8">Empresa / Documento</th>
                <th className="p-6 md:p-8 text-center">Responsável</th>
                <th className="p-6 md:p-8 text-center">Parque Ativo</th>
                <th className="p-6 md:p-8 text-right pr-12">Ação</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100/50">
              {isLoading ? (
                 <tr><td colSpan="4" className="p-20 text-center text-slate-400 font-black uppercase tracking-widest animate-pulse text-[10px]">Sincronizando...</td></tr>
              ) : filtered.map((c) => (
                <tr key={c.id} className="hover:bg-white/80 transition-all duration-300 group border-l-4 border-l-transparent hover:border-l-indigo-500">
                  <td className="p-6 md:p-8">
                    <p className="font-black text-slate-800 text-base md:text-lg uppercase tracking-tight group-hover:text-indigo-600 transition-colors">{c.name}</p>
                    <p className="text-[9px] text-slate-500 font-mono tracking-tighter mt-1 bg-slate-100/50 px-2 py-0.5 rounded w-fit uppercase">{c.cnpj || "Sem Documento"}</p>
                  </td>
                  <td className="p-6 md:p-8 text-center">
                     <p className="text-xs md:text-sm font-bold text-slate-600 truncate max-w-[150px] mx-auto">{c.contact || "---"}</p>
                     <p className="text-[9px] font-black text-indigo-500 mt-1 uppercase tracking-widest">{c.whatsapp || ""}</p>
                  </td>
                  <td className="p-6 md:p-8 text-center">
                    <span className="inline-flex items-center gap-2 bg-slate-100/80 text-slate-600 border border-slate-200 px-4 py-2 rounded-xl text-[9px] font-black uppercase tracking-widest shadow-sm">
                      {c.machines_count > 0 && <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></span>}
                      {c.machines_count} UN
                    </span>
                  </td>
                  <td className="p-6 md:p-8 text-right pr-12">
                    <div className="flex items-center justify-end gap-2">
                      <button onClick={() => handleOpenEdit(c)} className="w-9 h-9 flex items-center justify-center bg-white border border-slate-200 text-slate-400 rounded-lg hover:bg-indigo-50 hover:text-indigo-600 transition-all" title="Editar">✏️</button>
                      <button onClick={() => handleDelete(c)} className="w-9 h-9 flex items-center justify-center bg-white border border-slate-200 text-slate-400 rounded-lg hover:bg-rose-50 hover:text-rose-500 transition-all" title="Excluir">🗑️</button>
                      <button onClick={() => handleOpenInventory(c)} className="ml-2 bg-slate-900 text-white px-4 md:px-6 py-2.5 rounded-xl text-[9px] font-black uppercase tracking-widest hover:bg-indigo-600 transition-all">Inventário</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ➕ MODAL CADASTRO (RESPONSIVO COM SCROLL) */}
      <Modal isOpen={isNewClientOpen} onClose={() => setIsNewClientOpen(false)}>
        <div className="animate-in zoom-in-95 duration-300 w-full max-w-4xl p-2 max-h-[85vh] overflow-y-auto custom-scrollbar">
            <div className="flex justify-between items-center mb-6 border-b border-slate-100 pb-4">
                <div>
                    <h2 className="text-2xl md:text-3xl font-black tracking-tighter text-slate-900 uppercase leading-none">{editingClientId ? "Editar Cadastro" : "Novo Cliente"}</h2>
                    <p className="text-[9px] font-black text-indigo-500 uppercase mt-2 tracking-widest">Contrato & Faturamento</p>
                </div>
                <button onClick={() => setIsNewClientOpen(false)} className="text-slate-300 hover:text-rose-500 text-2xl font-black">✕</button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                {/* DADOS BÁSICOS */}
                <div className="col-span-1 md:col-span-12">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">Nome Comercial / Razão Social</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-black text-sm text-slate-800 outline-none focus:border-indigo-400 uppercase transition-all shadow-inner" value={newClient.name} onChange={e => setNewClient({...newClient, name: e.target.value})} />
                </div>

                <div className="col-span-1 md:col-span-6">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">CNPJ / CPF</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold text-sm text-slate-700 outline-none focus:border-indigo-400 transition-all" value={newClient.cnpj} onChange={e => setNewClient({...newClient, cnpj: maskCNPJ(e.target.value)})} placeholder="00.000.000/0000-00" />
                </div>
                <div className="col-span-1 md:col-span-6">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">Inscrição Estadual</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold text-sm text-slate-700 outline-none focus:border-indigo-400" value={newClient.state_registration} onChange={e => setNewClient({...newClient, state_registration: e.target.value})} placeholder="ISENTO ou Numérico" />
                </div>

                {/* CONTATOS */}
                <div className="col-span-1 md:col-span-4">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">Telefone / WhatsApp</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold text-sm text-slate-700 outline-none focus:border-indigo-400" value={newClient.whatsapp} onChange={e => setNewClient({...newClient, whatsapp: maskPhone(e.target.value)})} placeholder="(00) 00000-0000" />
                </div>
                <div className="col-span-1 md:col-span-4">
                    <label className="text-[9px] font-black uppercase text-indigo-400 ml-2 mb-1 block">E-mails (NFe)</label>
                    <input className="w-full p-4 bg-indigo-50/30 border border-indigo-100 rounded-xl font-bold text-sm text-indigo-700 outline-none focus:border-indigo-400" value={newClient.email} onChange={e => setNewClient({...newClient, email: e.target.value})} placeholder="contabilidade@..." />
                </div>
                <div className="col-span-1 md:col-span-4">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">Pessoa de Contato</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold text-sm text-slate-700 outline-none focus:border-indigo-400" value={newClient.contact_person} onChange={e => setNewClient({...newClient, contact_person: e.target.value})} placeholder="Ex: João - T.I" />
                </div>

                <div className="col-span-1 md:col-span-12 border-t border-slate-100 my-2"></div>

                {/* LOGÍSTICA (CEP AUTO) */}
                <div className="col-span-1 md:col-span-3">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">CEP</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold text-sm text-center outline-none focus:ring-4 ring-indigo-500/5 shadow-inner" value={newClient.zipcode} onChange={e => { const m = maskCEP(e.target.value); setNewClient({...newClient, zipcode: m}); fetchAddressByCep(m); }} placeholder="00000-000" />
                </div>
                <div className="col-span-1 md:col-span-9">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">Logradouro (Rua, Nº, Compl.)</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-black text-sm text-slate-800 outline-none focus:border-indigo-400 uppercase transition-all" value={newClient.address} onChange={e => setNewClient({...newClient, address: e.target.value})} />
                </div>

                <div className="col-span-1 md:col-span-5">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">Bairro</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-black text-sm text-slate-800 uppercase outline-none focus:border-indigo-400" value={newClient.neighborhood} onChange={e => setNewClient({...newClient, neighborhood: e.target.value})} />
                </div>
                <div className="col-span-1 md:col-span-5">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block">Cidade</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-black text-sm text-slate-800 uppercase outline-none focus:border-indigo-400" value={newClient.city} onChange={e => setNewClient({...newClient, city: e.target.value})} />
                </div>
                <div className="col-span-1 md:col-span-2">
                    <label className="text-[9px] font-black uppercase text-slate-400 ml-2 mb-1 block text-center">UF</label>
                    <input className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-black text-sm text-center uppercase outline-none" value={newClient.state_uf} onChange={e => setNewClient({...newClient, state_uf: maskUF(e.target.value)})} maxLength={2} />
                </div>

                <button onClick={handleSave} className="col-span-1 md:col-span-12 py-5 bg-indigo-600 text-white font-black rounded-2xl mt-4 shadow-lg hover:bg-indigo-500 active:scale-95 transition-all uppercase text-[10px] tracking-widest">
                    {editingClientId ? "Salvar Atualização 💾" : "Registrar Novo Cliente 🚀"}
                </button>
            </div>
        </div>
      </Modal>

      {/* 🖨️ MODAL INVENTÁRIO (RESPONSIVO) */}
      <Modal isOpen={isInventoryOpen} onClose={() => setIsInventoryOpen(false)}>
        <div className="p-2 w-full max-w-2xl max-h-[80vh] overflow-y-auto custom-scrollbar">
            <div className="flex justify-between items-center mb-6 border-b border-slate-100 pb-4">
                <div>
                    <h2 className="text-xl md:text-2xl font-black uppercase text-slate-900">Parque Ativo</h2>
                    <p className="text-[9px] font-black text-indigo-500 uppercase mt-1 truncate">{selectedClient?.name}</p>
                </div>
                <button onClick={() => setIsInventoryOpen(false)} className="text-slate-300 text-2xl font-black">✕</button>
            </div>
            
            <div className="bg-slate-50/50 rounded-2xl border border-slate-100 overflow-x-auto">
              <table className="w-full text-left min-w-[450px]">
                <thead className="bg-white border-b text-[8px] font-black uppercase text-slate-400 tracking-widest">
                  <tr><th className="p-4">Modelo</th><th className="p-4">S/N</th><th className="p-4 text-right">Ação</th></tr>
                </thead>
                <tbody className="divide-y divide-slate-100/50">
                  {inventory.length > 0 ? inventory.map(p => (
                    <tr key={p.id} className="hover:bg-white transition-colors group">
                      <td className="p-4 font-black text-slate-800 uppercase text-xs">{p.model}</td>
                      <td className="p-4 font-mono text-[9px] text-slate-400">{p.serial || "S/S"}</td>
                      <td className="p-4 text-right">
                        <Link to={`/printers/${p.id}`} className="bg-white border border-slate-200 text-slate-500 px-4 py-2 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-indigo-600 hover:text-white transition-all">Prontuário</Link>
                      </td>
                    </tr>
                  )) : <tr><td colSpan="3" className="p-10 text-center text-slate-400 font-black uppercase text-[9px]">Nenhuma máquina alocada.</td></tr>}
                </tbody>
              </table>
            </div>
        </div>
      </Modal>

    </div>
  );
}